<template>
  <div
    v-if="!$store.state.View.takt_time_filter.active || (takt_index > $store.state.View.takt_time_filter.start && takt_index < $store.state.View.takt_time_filter.end)"
    class="waggon-intersection-placeholder"
    v-intersect="onintersect"
  >
  <v-hover
    :disabled="$store.state.View.taktarea_dragging || getMoveTaktareaStartVariables.move_taktarea_start"
    v-model="hover"
    >
    <template>
    <transition
      :name="waggon_transition?'grow-x':''"
      >
      <!-- :easter_egg="!isEditMode && waggon.tworkpackages[0] % 10 === 0 && hover" -->
      <TContextInformation v-if="show_waggon || dragging || $store.state.View.is_printing_mode">
        <template #default>
          <TWaggon
            :class="hover && waggon[tworkpackages_string].length === 0 && $route.name !== 'ProjectTaktPlan'?
                           'cursor-pointer':''"
            :key="`waggon${waggon.id}`"
            :workpackage_count="waggon[tworkpackages_string].length"
            :easter_egg="false"
            >
            <template #prepend
              v-if="hover && isEditMode"
    
              >
              <Activator
                :key="`waggonactivatorprepend${waggon.id}`"
                v-if="($route.name === 'ProjectTaktPlan' && hasProjectPermission({'project_id': project_id, ppermission: 'Add Waggons'}))"
                class="self-centered cursor-cell"
                @click.native="$router.push({
                    name: 'AddTWaggon',
                    params: {
                      project_id: project_id,
                      train_id: train.id,
                      taktarea_id: taktarea.id,
                      twaggon_index: waggon_index,
                      reference: {
                        before: true,
                        type: 'twaggons',
                        id: waggon.id
                      }
                    }
                  })"
              />
    
              <Activator
                :key="`waggonactivatorprepend${waggon.id}`"
                v-if="$route.matched[3] && 
                      $route.matched[3].name === 'TaktPlanWorkPackageInfo' && 
                      waggon.tworkpackages.includes(parseInt($route.params.tworkpackage_id)) && 
                      hasProjectPermission({'project_id': project_id, ppermission: 'Add Work Packages'})
                      "
                class="self-centered cursor-cell"
                @click.native="$router.push({
                    name: 'ExtendTWorkPackage',
                    params: {
                      project_id: project_id,
                      train_id: train.id,
                      taktarea_id: taktarea.id,
                      twaggon_index: waggon_index,
                      tworkpackage_id: $route.params.tworkpackage_id,
                      reference: {
                        before: true,
                        type: 'twaggons',
                        id: waggon.id
                      }
                    }
                  })"
              />
            </template>
            <template #append
              v-if="hover && isEditMode"
              >
              <Activator
                :key="`waggonactivatorappend${waggon.id}`"
                class="self-centered cursor-cell"
                v-if="$route.name === 'ProjectTaktPlan' && hasProjectPermission({'project_id': project_id, ppermission: 'Add Waggons'})"
                @click.native="$router.push({
                    name: 'AddTWaggon',
                    params: {
                      project_id: project_id,
                      train_id: train.id,
                      taktarea_id: taktarea.id,
                      twaggon_index: waggon_index,
                      reference: {
                        before: false,
                        type: 'twaggons',
                        id: waggon.id
                      }
                    }
                  })"
              />
              <Activator
                :key="`waggonactivatorappend${waggon.id}`"
                class="self-centered cursor-cell"
                v-if="$route.matched[3] && 
                      $route.matched[3].name === 'TaktPlanWorkPackageInfo' && 
                      waggon.tworkpackages.includes(parseInt($route.params.tworkpackage_id)) && 
                      hasProjectPermission({'project_id': project_id, ppermission: 'Add Work Packages'})
                      "
                @click.native="$router.push({
                    name: 'ExtendTWorkPackage',
                    params: {
                      project_id: project_id,
                      train_id: train.id,
                      taktarea_id: taktarea.id,
                      twaggon_index: waggon_index,
                      tworkpackage_id: $route.params.tworkpackage_id,
                      reference: {
                        before: false,
                        type: 'twaggons',
                        id: waggon.id
                      }
                    }
                  })"
              />
            </template>
            <template #badge>
              <StandardDeleteButton
                v-if="hover && isEditMode && $route.name === 'ProjectTaktPlan' && hasProjectPermission({'project_id': project_id, ppermission: 'Delete Waggons'})"
                :key="`waggonbadge${waggon.id}`"
                direction="left"
                @clickDelete="requestSnackbarDelete({
                    url: [
                      {projects: project_id},
                      {trains: train.id},
                      {taktareas: taktarea.id},
                      {twaggons: waggon.id}
                    ],
                    selector: 'target'
                  }).then((payload) => {
                    deleteUObject(payload).then(() => {
                      updateCalenderLookup(project_id)
                    })
                  })"
              />
            </template>
            <template #content="{easter_egg}">
              <StandardHover
                v-if="
                      isTWaggonHover(waggon.id, hover)
    
                "
                :key="`waggonhover${waggon.id}`"
                :easter_egg="easter_egg"
                :class="easter_egg?'cursor-none':(isEditMode? 'cursor-grab':waggon[tworkpackages_string].length !== 0?'cursor-pointer':'cursor-default')"
                @click.native="handleWaggonClick(waggon, train.id, taktarea.id, waggon.id, $event)"
              />
              <div
              v-if="$store.state.View.isMacroView" class="makro-view"
              @click="handleWaggonClick(waggon, train.id, taktarea.id, waggon.id, $event)"
              >
                {{ waggon_index + 1}}
                <!-- {{ takt_index }} -->
              </div>
              <div
                v-if="$store.state.View.isTokenView && !isEditMode" class="token-view" style="cursor: pointer;"
                @click="handleWaggonClick(waggon, train.id, taktarea.id, waggon.id, $event)"
              >
                <StandardBadge
                  class="cursor-pointer"
                  v-if="$store.state.Project.show_status_badges && $store.state.View.isTokenView && getTWaggonStatus(waggon.id).value !== 'none'"
                  :icon="getTWaggonStatus(waggon.id).icon"
                  color="white"
                  :content_color="getTWaggonStatus(waggon.id).value === 'stop' ? 'red':'black'"
                />
                {{ waggon.token ? waggon.token : ''}}
              </div>
              <div
                v-if="$store.state.View.isTokenView && isEditMode" class="token-view"
                @click="handleWaggonClick(waggon, train.id, taktarea.id, waggon.id, $event)"
              >
                <StandardBadge
                  class="cursor-pointer"
                  v-if="$store.state.Project.show_status_badges && $store.state.View.isTokenView && getTWaggonStatus(waggon.id).value !== 'none'"
                  :icon="getTWaggonStatus(waggon.id).icon"
                  color="white"
                  :content_color="getTWaggonStatus(waggon.id).value === 'stop' ? 'red':'black'"
                />
                <input class="waggon-token-input" type="text" maxlength="5" :value="waggon.token ? waggon.token : ''"
                  :disabled="snackbar && snackbar.show && snackbar.selector"
                  @change="requestSnackbarUpdate({
                    url: [
                      {projects: project_id},
                      {trains: train.id},
                      {taktareas: taktarea.id},
                      {twaggons: waggon.id},
                    ],
                    update: {
                      token: $event.target.value
                    },
                    selector: 'target'
                  }).then((payload) => {
                    updateUObject(payload);
                  })" />
              </div>
              <draggable
                class="display-flex flex-wrap"
                :key="`workpackageswaggon${waggon.id}`"
                :id="`workpackageswaggon${waggon.id}`"
                :group="`workpackages_taktarea_${taktarea.id}`"
                :component-data="getDraggableStyle()"
                animation="300"
                forceFallback="true"
                fallbackOnBody="true"
                :disabled="!hover || !isEditMode ||
                           !($route.matched[3] && $route.matched[3].name === 'TaktPlanWorkPackageInfo') || 
                           !hasProjectPermission({'project_id': project_id, ppermission: 'Update Work Packages'})?
                           true:false"
                :value="waggon.tworkpackages"
                @update="requestSnackbarUpdatePosition({
                    url: [
                      {projects: project_id},
                      {trains: train.id},
                      {taktareas: taktarea.id},
                      {twaggons: waggon.id},
                      {tworkpackages: waggon.tworkpackages[$event.oldIndex]}
                    ],
                    update: {
                      position: $event.newIndex - $event.oldIndex
                    },
                    selector: 'parent',
                    limit_selector: true
                  }).then((payload) => {
                    updateUObjectPosition(payload)
                })"
                @start="draggable_old_twaggon_id = waggon.id"
                @remove="test($event); requestSnackbarUpdateParent({
                  url: [
                    {projects: project_id},
                    {trains: train.id},
                    {taktareas: taktarea.id},
                    {twaggons: waggon.id},
                    {tworkpackages: waggon.tworkpackages[$event.oldIndex]},
                    {updateparent: ''}
                  ],
                  update: {
                    parent_id: parseInt($event.to.id.substring(18, $event.to.id.length)),
                    position: $event.newIndex + parseInt(1),
                  },
                  selector: 'parent',
                  limit_selector: true
                }).then((payload) => {
                    updateUObjectParent(payload)
                  })
                "
              >
              <TPWorkpackage
                v-for="workpackage in tworkpackages"
                :key="`workpackagehoveractivator${workpackage.id}`"
                :project_id="project_id"
                :workpackage="workpackage"
                :train="train"
                :taktarea="taktarea"
                :location="location"
                :waggon="waggon"
                :easter_egg="!isEditMode && false && workpackage.id % 26 === 0 && hover"
                :new_milestone="new_milestone"
                :milestone_selection="milestone_selection"
                :snackbar="snackbar"
                :hover_waggon="hover"
                @openWaggonInfo="handleWaggonClick(waggon, train.id, taktarea.id, waggon.id, $event, workpackage)" 
              />
              <!-- @openWaggonInfo="openWaggonInfo(waggon, train.id, taktarea.id, waggon.id, $event, workpackage.id)" 
              @openWaggonInfo="openWPInfo(train.id,taktarea.id,waggon.id,$event,workpackage.id)"-->
            </draggable>
            </template>
          </TWaggon>
        </template>
        <template #information>
          <WorkpackageInformation v-for="workpackage in tworkpackages" :key="`wp-info-${workpackage.id}`" :workpackage="workpackage" prefix="t" histprefix="" />
        </template>
      </TContextInformation>
    </transition>
    </template>
  </v-hover>
</div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

import draggable from "vuedraggable";
import TPWorkpackage from '@/views/Project/ProjectTaktPlan/TPWorkpackage.wrapper.vue';
import TWaggon from '@/components/ProjectTaktPlan/Waggon.component.vue';
import StandardHover from '@/components/StandardComponents/StandardHover.component.vue'
import Activator from '@/components/ProjectTaktPlan/Activator.component.vue'
import StandardDeleteButton from '@/components/StandardComponents/StandardDeleteButton.component.vue'
import StandardBadge from '@/components/StandardComponents/StandardBadge.component.vue'

import WorkpackageInformation from '@/components/ProjectTaktPlan/WorkpackageInformation.component.vue';
import TContextInformation from '@/components/Taktify/TContextInformation.component.vue';
  export default {
    props: [
      'waggon_transition',
      'project_id',
      'train',
      'taktarea',
      'waggon',
      'waggon_index',
      'snackbar',
      'new_milestone',
      'location',
      'milestone_selection',
      'dragging',
      'takt_index',
    ],
    components: {
      draggable,
      TPWorkpackage,
      TWaggon,
      StandardHover,
      Activator,
      StandardDeleteButton,
      StandardBadge,
      WorkpackageInformation,
      TContextInformation
    },
    data: () => ({
      show_waggon: false,
      hover: false,
    }),
    mounted(){
      window.addEventListener('keyup', this.onKeyUp)
    },
    unmounted(){
      window.removeEventListener('keyup', this.onKeyUp)
    },
    // updated() {
    //   console.log('tpwaggon updated');
    // },
    computed: {
      tworkpackages_string(){
        if (this.location === 'HistProject') {
          return 'histtworkpackages';
        } else {
          return 'tworkpackages';
        }
      },
      tworkpackages(){
        if (this.location === 'HistProject') {
          return this.getUObjects({type: 'histtworkpackages', ids: this.waggon.histtworkpackages});
        } else {
          return this.getUObjects({type: 'tworkpackages', ids: this.waggon.tworkpackages});
        }
      },
      ...mapGetters('Ultra', [
        'getUObjects',
      ]),
      ...mapGetters('Project', [
        'isEditMode',
        'hasProjectPermission',
      ]),
      ...mapGetters('TaktArea', [
        'getMoveTaktareaStartVariables',
      ]),
      ...mapGetters('TWaggon', [
        'getTWaggonStatus',
      ]),
      ...mapGetters('SnackBar', [
        'getAffectedTargets',
        'getAffectedIdsSelector'
      ]),
    },
    methods: {
      test(d) {
        console.log("ipdatePosition", d);
      },
      onKeyUp(e){
        if (this.hover && (!document.activeElement || (document.activeElement && !['TEXTAREA', 'INPUT'].includes(document.activeElement.tagName)))) {
          const reg = new RegExp('^[0-9]$');
          const status_lookup = {
            '1': 'ready',
            '2': 'started',
            '3': 'done',
            '4': 'checked',
            '5': 'closed',
            '0': 'none',
          }
          if(reg.test(e.key)) {
            let value = parseInt(e.key);
            const workpackages = this.getUObjects({type: 'tworkpackages', ids: this.waggon.tworkpackages});
            workpackages.forEach(wp => {
              this.updateUObject({
                url: [
                  {projects: this.project_id},
                  {trains: this.train.id},
                  {taktareas: this.taktarea.id},
                  {twaggons: this.waggon.id},
                  {tworkpackages: wp.id}
                ],
                update: {
                  status: status_lookup[value]
                }
              })
            });
          }
        }
      },
      onintersect(entries, observer, isIntersecting) {
        if (this.$store.state.View.use_intersection_observer === false) {
          this.show_waggon = true;
        } else {
          if (isIntersecting) {
            this.show_waggon = true;
          } else {
            this.show_waggon = false;
          }
        }
      },
      ...mapActions('Ultra', [
        'createUObject',
        'updateUObject',
        'updateUObjectParent',
        'deleteUObject',
        'updateUObjectPosition',
      ]),
      ...mapActions('ProjectCalendar', [
        'updateCalenderLookup',
      ]),
      ...mapActions('SnackBar', [
        'requestSnackbarCreate',
        'requestSnackbarUpdate',
        'requestSnackbarUpdatePosition',
        'requestSnackbarUpdateParent',
        'requestSnackbarDelete',
        'editAffectedReferences',
        'editSelector'
      ]),
      handleWaggonClick(waggon, train_id, taktarea_id, waggon_id, evt, workpackage){
        if (this.snackbar && this.snackbar.show && this.snackbar.selector){
          this.editSelector(waggon_id);
        } else {
          if (workpackage){
            this.openWPInfo(this.train, this.taktarea, this.waggon, workpackage)
          } else if (!(this.$store.state.View.isTokenView && this.isEditMode)) {
            this.openWaggonInfo(waggon, train_id, taktarea_id, waggon_id, evt)
          }
        }
      },
      getDraggableStyle(){
        return {attrs: {'style': `width: calc((var(--workpackage_width) + 4px) * var(--taktplan_zoom)); height: calc((var(--workpackage_height) + 4px) * var(--taktplan_zoom))`}};
      },
      isTWaggonHover(waggon_id, hover){
        if (this.snackbar && this.snackbar.show && this.snackbar.selector){
          if (this.snackbar[this.snackbar.selector.select_key + '_type'] != 'twaggons') {
            return false;
          }
          if (this.snackbar[this.snackbar.selector.select_key + '_type'] == 'twaggons' && hover){
            return true;
          }
        }
        if ((this.$route.params.twaggon_id == waggon_id && this.tworkpackages.length === 0) ||
                  (hover && ((this.$route.name === 'ProjectTaktPlan' || this.$route.name === 'HistProjectTaktPlan') || this.tworkpackages.length === 0))) {
          return true;
        }
        if (this.snackbar && this.snackbar.show) {
          if (this.snackbar.selector && 
            this.snackbar[this.snackbar.selector.select_key + '_type'] == 'twaggons' && 
            (this.getAffectedIdsSelector.includes(waggon_id) || this.snackbar[this.snackbar.selector.select_key + '_id'] == waggon_id)) {
            return true;
          }
          else if (
                  (this.snackbar && this.snackbar.show && this.snackbar.hover && this.snackbar.target_type === 'twaggons' && this.snackbar.action === 'create' && this.snackbar.affected_references.includes(waggon_id)) ||
                  (this.snackbar && this.snackbar.show && this.snackbar.hover && this.snackbar.target_type === 'twaggons' && this.snackbar.action !== 'create' && (this.getAffectedTargets.includes(waggon_id))) ||
                  (this.snackbar && this.snackbar.show && this.snackbar.hover && this.snackbar.target_type === 'tworkpackages' && this.snackbar.action === 'create' && this.snackbar.affected_parents.includes(waggon_id)) ||
                  (this.snackbar && this.snackbar.show && this.snackbar.hover && this.snackbar.action === 'updateparent' && (this.snackbar.affected_parents.includes(waggon_id) || this.snackbar.affected_new_parents.includes(waggon_id)))
                  ){
                    return true;
          }
        }
        return false;
      },
      openWPInfo(train,taktarea,waggon,workpackage){
        let route_name = this.$route.name;
        if (this.$route.name.includes('Backlog')) {
          route_name = `${this.location === 'HistProject'?'HistProject':''}TaktPlanWorkPackageInfo`;
        }
        if (route_name === 'HistProjectTaktPlan' || route_name === 'TaktPlan') {
          route_name = route_name + 'WorkPackageInfo';
        }
        if (this.$route.params.tworkpackage_id != workpackage.id) {
          if (route_name === 'TaktPlanAddWorkPackage') {
            route_name = "TaktPlanWorkPackageInfo"
          }
          this.$router.push({
            name: route_name,
            params: {
              train_id: train.id,
              taktarea_id: taktarea.id,
              twaggon_id: waggon.id,
              tworkpackage_id: workpackage.id
            }
          });
        }
      },
      openWaggonInfo(waggon, train_id, taktarea_id, waggon_id, evt, workpackage_id) {
        let x =  -window.innerWidth/2 + evt.clientX;
        let y = -window.innerHeight/2 + evt.clientY;
        document.body.style.setProperty('--waggon_offset_x', `${x}px`);
        document.body.style.setProperty('--waggon_offset_y', `${y}px`);
        if (waggon[this.tworkpackages_string].length > 0) {
          if (this.location === 'HistProject') {
            this.$router.push({
              name: 'HistProjectTaktPlanWorkPackageInfo',
              params: {
                train_id: train_id,
                taktarea_id: taktarea_id,
                twaggon_id: waggon_id,
                tworkpackage_id: workpackage_id?workpackage_id:waggon.histtworkpackages[0],
              }
            });
          } else {
            this.$router.push({
              name: this.isEditMode?'TaktPlanWorkPackageEdit':'TaktPlanWorkPackageInfo',
              params: {
                train_id: train_id,
                taktarea_id: taktarea_id,
                twaggon_id: waggon_id,
                tworkpackage_id: workpackage_id?workpackage_id:waggon.tworkpackages[0],
              }
            });
          }
        } else if (this.isEditMode) {
          this.$router.push({
            name: 'TaktPlanAddWorkPackage',
            params: {
              train_id: train_id,
              taktarea_id: taktarea_id,
              twaggon_id: waggon_id,
              }
            });
        }
      },
    }
  }
</script>
<style>
  .waggon-intersection-placeholder{
    width: calc((var(--workpackage_width) + 8px) * var(--taktplan_zoom));
    height: calc((var(--workpackage_height) + 8px) * var(--taktplan_zoom));
  }
  .makro-view {
    height: 100%;
    width: 100%;
    background-color: rgb(138 138 138 / 50%);
    position: absolute;
    z-index: 2;
    text-align: center;
    padding-top: 7px;
    cursor: pointer;
  }
  .token-view {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    height: 100%;
    width: 100%;
    background-color: rgb(106 106 106 / 80%);
    z-index: 2;
    font-weight: bold;
  }
  .waggon-token-input {
    width: 100%;
    height: 100%;
    padding: 2px;
    text-align: center;
  }
</style>
